import { all, call, put, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import ApiClient from '../../../services/ApiClient'
import apiUrl from '../../../services/apiUrl'
import { importUsers, importUsersSuccess, importUsersFail } from './ImportUsersAdminActions'

function* sagaImportUsers({ payload }: any) {
  try {
    const { file, companyId, updateIfExists } = payload

    const formData = new FormData()
    formData.append('file', file)
    formData.append('companyId', companyId)
    formData.append('updateIfExists', String(updateIfExists))

    const response: any = yield call(ApiClient.post, 'importUsers', formData, {
      baseURL: apiUrl('/'),
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000,
    })

    yield put({ type: String(importUsersSuccess), payload: response })

    const result = response
    const notification: INotification = {
      type: 'success',
      content: t`Import complete. Created: ${result.created}, Updated: ${result.updated}, Skipped: ${result.skipped}.`,
    }
    yield put({ type: String(addNotification), payload: notification })
  } catch (e: any) {
    const errorResponse = e?.data
    if (errorResponse && errorResponse.errors) {
      yield put({ type: String(importUsersSuccess), payload: errorResponse })
    } else {
      yield put({ type: String(importUsersFail) })
      const notification: INotification = {
        type: 'warning',
        content: e.message || t`Import failed. Please try again.`,
      }
      yield put({ type: String(addNotification), payload: notification })
    }
  }
}

export function* importUsersAdminSagas() {
  yield all([takeEvery(String(importUsers), sagaImportUsers)])
}
